import React, { useMemo } from 'react';
import { FiHash, FiInbox, FiPauseCircle, FiCheckCircle } from 'react-icons/fi';
import { useTranslation } from 'react-i18next';
import i18n from '../../../../i18n';

const CLAVES_ESTADO = [
  { clave: 'abierto', icono: FiInbox },
  { clave: 'retenido', icono: FiPauseCircle },
  { clave: 'cerrado', icono: FiCheckCircle },
];

/** "hace 3 días" a partir de una fecha, sin arrastrar una librería para esto. */
const desde = (fecha) => {
  const dias = Math.floor((Date.now() - new Date(fecha).getTime()) / 86400000);
  if (dias <= 0) return i18n.t('perfilUsuario.hoy');
  if (dias === 1) return i18n.t('perfilUsuario.ayer');
  if (dias < 30) return i18n.t('perfilUsuario.haceDias', { count: dias });
  const meses = Math.floor(dias / 30);
  return meses === 1 ? i18n.t('perfilUsuario.haceUnMes') : i18n.t('perfilUsuario.haceMeses', { count: meses });
};

/**
 * Actividad del usuario en cifras: cuántos tickets ha creado y cómo se
 * reparten por estado. La barra de cada tarjeta es la proporción sobre el
 * total, para leer el reparto sin comparar números.
 */
const KpisTickets = ({ tickets, cargando }) => {
  const { t } = useTranslation();
  const conteo = useMemo(() => tickets.reduce((acc, t) => {
    acc[t.estado_del_ticket] = (acc[t.estado_del_ticket] || 0) + 1;
    return acc;
  }, {}), [tickets]);

  const total = tickets.length;
  const ultimo = total > 0 ? tickets[0] : null;

  if (cargando) {
    return (
      <div className="pu-kpis">
        {['total', 'abierto', 'retenido', 'cerrado'].map((clave) => (
          <div key={clave} className={`pu-kpi pu-kpi--${clave}`}>
            <div className="pu-skeleton" aria-hidden="true"><span /><span /></div>
          </div>
        ))}
      </div>
    );
  }

  return (
    <div className="pu-kpis">
      <div className="pu-kpi pu-kpi--total">
        <span className="pu-kpi-icono"><FiHash /></span>
        <span className="pu-kpi-valor">{total}</span>
        <span className="pu-kpi-label">{t('perfilUsuario.ticketsCreados')}</span>
        <span className="pu-kpi-pie">
          {ultimo ? t('perfilUsuario.ultimoHace', { tiempo: desde(ultimo.createdAt) }) : t('perfilUsuario.sinActividadTodavia')}
        </span>
      </div>

      {CLAVES_ESTADO.map(({ clave, icono: Icono }) => {
        const valor = conteo[clave] || 0;
        const porcentaje = total > 0 ? Math.round((valor / total) * 100) : 0;
        return (
          <div key={clave} className={`pu-kpi pu-kpi--${clave}`}>
            <span className="pu-kpi-icono"><Icono /></span>
            <span className="pu-kpi-valor">{valor}</span>
            <span className="pu-kpi-label">{t(`perfilUsuario.estadosPlural.${clave}`)}</span>
            <span className="pu-kpi-pie">{t('perfilUsuario.porcentajeDelTotal', { porcentaje })}</span>
            <span className="pu-kpi-barra"><span style={{ width: `${porcentaje}%` }} /></span>
          </div>
        );
      })}
    </div>
  );
};

export default KpisTickets;
